import script from "./EmployeeItem.vue?vue&type=script&setup=true&lang=js"
export * from "./EmployeeItem.vue?vue&type=script&setup=true&lang=js"

import "./EmployeeItem.vue?vue&type=style&index=0&id=a2c75580&lang=scss"
import "./EmployeeItem.vue?vue&type=style&index=1&id=a2c75580&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a2c75580"]])

export default __exports__